export default __webpack_public_path__ + "static/media/resetlink.fda47d41.svg";